import { Center, ConditionalRendering, Loader, Text } from "@marketplace/ui";
import { getRouteApi } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { Pagination } from "@/components";
import { TransactionsEmptyState } from "@/modules/shared";

import { RecurringOrdersFilter } from "../../components/recurring-orders-filter";
import { RecurringOrdersTable } from "../../components/recurring-orders-table";
import { useGetRecurringOrderListQuery } from "../../hooks/queries/use-get-recurring-order-list-query";

const route = getRouteApi("/recurring-orders/");

export const RecurringOrderListPage = () => {
  const { page, q, sort } = route.useSearch();
  const navigate = route.useNavigate();
  const { t } = useTranslation("order", {
    keyPrefix: "recurringOrderListPage"
  });

  const { data: responseData, isLoading } = useGetRecurringOrderListQuery({
    queryParams: {
      page,
      limit: 10,
      q,
      sort
    }
  });

  const metadata = responseData?.metadata;
  const records = responseData?.data ?? [];

  return (
    <>
      <div className="mb-6">
        <Text type="heading" size="l" className="text-humble-blue-500">
          {t("title")}
        </Text>
        <Text size="l" className="text-fjord-grey-400">
          {t("description")}
        </Text>
      </div>

      <RecurringOrdersFilter />

      <ConditionalRendering condition={!isLoading && !records.length}>
        <div className="relative mt-[42px] flex justify-center">
          <TransactionsEmptyState />
          <Text
            type="heading"
            className="absolute bottom-[65px] text-fjord-grey-500"
          >
            {t("emptyStateLabel.default")}
          </Text>
        </div>
      </ConditionalRendering>

      <ConditionalRendering condition={records && records.length > 0}>
        <div className="space-y-6">
          <RecurringOrdersTable records={records} />
          <Pagination
            currentPageTotal={records.length}
            totalData={metadata?.total}
            total={metadata?.totalPage ?? 0}
            value={metadata?.page}
            onChange={(value) =>
              navigate({
                search: (prev) => ({
                  ...prev,
                  page: value
                })
              })
            }
          />
        </div>
      </ConditionalRendering>

      <ConditionalRendering condition={isLoading}>
        <Center className="my-20">
          <Loader />
        </Center>
      </ConditionalRendering>
    </>
  );
};
